import React, { useState } from 'react';
import { ArrowRight, Mail, CheckCircle2, Dog, Cat, ShieldCheck, Loader2, Heart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import confetti from 'canvas-confetti';
export function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1500));
    setIsSubmitting(false);
    setIsSubscribed(true);
    confetti({
      particleCount: 150,
      spread: 70,
      origin: {
        y: 0.6
      },
      colors: ['#2563EB', '#10B981', '#F59E0B']
    });
  };
  return <section className="py-24 lg:py-32 bg-charcoal-900 relative overflow-hidden" data-id="element-3916">
      {/* Background Decor */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10" data-id="element-3917" />
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-900/40 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/3" data-id="element-3918" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-purple-900/30 rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" data-id="element-3919" />

      <div className="container-custom max-w-6xl mx-auto relative z-10" data-id="element-3920">
        <div className="bg-white/5 backdrop-blur-lg rounded-[3rem] p-8 md:p-16 border border-white/10 relative overflow-hidden" data-id="element-3921">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3922">
            {/* Left: Content */}
            <div className="text-white" data-id="element-3923">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-sm font-bold mb-8" data-id="element-3924">
                <Heart className="w-4 h-4 text-rose-400 fill-rose-400" data-id="element-3925" />
                <span data-id="element-3926">Únete a 50,000+ Pet Lovers</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-3927">
                Consejos expertos para <br data-id="element-3928" />
                <span className="text-primary-400" data-id="element-3929">una vida mejor</span>
              </h2>

              <p className="text-gray-300 text-lg mb-10 leading-relaxed font-light" data-id="element-3930">
                Recibe guías de nutrición, alertas de salud y ofertas
                exclusivas. Sin spam, solo contenido que tu mascota agradecería
                si pudiera leer.
              </p>

              <div className="flex flex-wrap gap-6" data-id="element-3931">
                {[{
                icon: Dog,
                text: 'Guías de Raza'
              }, {
                icon: ShieldCheck,
                text: 'Alertas Salud'
              }, {
                icon: Cat,
                text: 'Tips Comportamiento'
              }].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white/5 px-4 py-3 rounded-xl border border-white/5" data-id="element-3932">
                    <item.icon className="w-5 h-5 text-primary-400" data-id="element-3933" />
                    <span className="font-bold text-sm" data-id="element-3934">{item.text}</span>
                  </div>)}
              </div>
            </div>

            {/* Right: Form */}
            <div className="relative" data-id="element-3935">
              <AnimatePresence mode="wait" data-id="element-3936">
                {!isSubscribed ? <motion.form key="form" initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -20
              }} onSubmit={handleSubmit} className="bg-white rounded-[2.5rem] p-8 md:p-10 shadow-2xl" data-id="element-3937">
                    <div className="text-center mb-8" data-id="element-3938">
                      <div className="w-16 h-16 bg-primary-50 rounded-2xl flex items-center justify-center text-primary-600 mx-auto mb-4 rotate-3" data-id="element-3939">
                        <Mail className="w-8 h-8" data-id="element-3940" />
                      </div>
                      <h3 className="text-2xl font-bold text-charcoal-900 font-serif" data-id="element-3941">
                        Tu regalo de bienvenida
                      </h3>
                      <p className="text-charcoal-500" data-id="element-3942">
                        Suscríbete y recibe un 10% de descuento.
                      </p>
                    </div>

                    <div className="space-y-4" data-id="element-3943">
                      <div data-id="element-3944">
                        <label className="block text-sm font-bold text-charcoal-700 mb-2 ml-1" data-id="element-3945">
                          Tu Email
                        </label>
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="nombre@ejemplo.com" className="w-full h-14 px-6 rounded-xl bg-gray-50 border-2 border-gray-100 focus:border-primary-500 focus:bg-white transition-all outline-none text-lg" required data-id="element-3946" />
                      </div>

                      <Button type="submit" size="xl" fullWidth disabled={isSubmitting} className="h-14 rounded-xl text-lg shadow-lg shadow-primary-900/20" data-id="element-3947">
                        {isSubmitting ? <Loader2 className="w-6 h-6 animate-spin" data-id="element-3948" /> : 'Quiero mi descuento'}
                      </Button>
                    </div>

                    <p className="text-xs text-center text-gray-400 mt-6" data-id="element-3949">
                      Respetamos tu privacidad. Date de baja cuando quieras.
                    </p>
                  </motion.form> : <motion.div key="success" initial={{
                opacity: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                scale: 1
              }} className="bg-white rounded-[2.5rem] p-12 shadow-2xl text-center h-full flex flex-col justify-center items-center" data-id="element-3950">
                    <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-6 animate-bounce" data-id="element-3951">
                      <CheckCircle2 className="w-10 h-10" data-id="element-3952" />
                    </div>
                    <h3 className="text-2xl font-bold text-charcoal-900 font-serif mb-2" data-id="element-3953">
                      ¡Bienvenido!
                    </h3>
                    <p className="text-charcoal-600 mb-6" data-id="element-3954">
                      Revisa tu bandeja de entrada para confirmar y recibir tu
                      código.
                    </p>
                    <Button variant="outline" onClick={() => setIsSubscribed(false)} data-id="element-3955">
                      Volver
                    </Button>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>;
}